import React from 'react';
import { Link } from 'react-scroll';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// Importamos los nuevos iconos enfocados en Servicio y Valor Comercial
import { MapPin, Headphones, Smartphone, ShieldCheck } from 'lucide-react';
import './Hero.css';

const Hero = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    arrows: false,
  };

  return (
    <section id="home" className="hero">
      <div className="hero-slider">
        <Slider {...sliderSettings}>
          <div className="slide slide-1">
            <div className="slide-content">
              <h1>Inteligencia Telemática para Flotas de Alto Rendimiento</h1>
              <p>Mucho más que rastreo GPS. Audita hábitos de conducción, automatiza mantenimientos y controla activos con telemetría avanzada en tiempo real.</p>
              <div className="hero-buttons">
                <Link
                  to="contact"
                  spy={true}
                  smooth={true}
                  offset={-80}
                  duration={500}
                  className="btn btn-primary btn-lg"
                >
                  Solicitar Demo
                </Link>
                <Link
                  to="features"
                  spy={true}
                  smooth={true}
                  offset={-80}
                  duration={500}
                  className="btn btn-secondary btn-lg"
                >
                  Conocer Más
                </Link>
              </div>
            </div>
          </div>
          <div className="slide slide-2">
            <div className="slide-content">
              <h1>Centro de Monitoreo Inteligente con Alertas por Voz</h1>
              <p>Maximiza la reacción de tus operadores. Nuestra plataforma lee las incidencias críticas en voz alta (TTS) y permite enviar comandos remotos al instante.</p>
              <div className="hero-buttons">
                <Link
                  to="contact"
                  spy={true}
                  smooth={true}
                  offset={-80}
                  duration={500}
                  className="btn btn-primary btn-lg"
                >
                  Solicitar Demo
                </Link>
                <Link
                  to="how-it-works"
                  spy={true}
                  smooth={true}
                  offset={-80}
                  duration={500}
                  className="btn btn-secondary btn-lg"
                >
                  Cómo Funciona
                </Link>
              </div>
            </div>
          </div>
          <div className="slide slide-3">
            <div className="slide-content">
              <h1>Gestión Documental y Prevención de Riesgos</h1>
              <p>Evita multas y paralizaciones. Un sistema de semáforos inteligentes te avisa antes de que caduquen licencias, pólizas o mantenimientos.</p>
              <div className="hero-buttons">
                <Link
                  to="contact"
                  spy={true}
                  smooth={true}
                  offset={-80}
                  duration={500}
                  className="btn btn-primary btn-lg"
                >
                  Solicitar Demo
                </Link>
                <Link
                  to="benefits"
                  spy={true}
                  smooth={true}
                  offset={-80}
                  duration={500}
                  className="btn btn-secondary btn-lg"
                >
                  Ver Beneficios
                </Link>
              </div>
            </div>
          </div>
        </Slider>
      </div>

      <div className="hero-features">
        <div className="container">
          <div className="hero-features-grid">
            <div className="feature-item">
              <div className="feature-icon">
                <MapPin size={24} />
              </div>
              <h3>Monitoreo Activo 24/7</h3>
              <p>Cobertura ininterrumpida y visibilidad global de tu flota</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon">
                <Headphones size={24} />
              </div>
              <h3>Soporte Especializado</h3>
              <p>Asistencia técnica dedicada para garantizar tu operatividad</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon">
                <Smartphone size={24} />
              </div>
              <h3>Ecosistema Móvil</h3>
              <p>Control total desde cualquier dispositivo en tiempo real</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon">
                <ShieldCheck size={24} />
              </div>
              <h3>Infraestructura Segura</h3>
              <p>Protección de datos y servidores de alta disponibilidad</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;